import translations from '../../components/location/ts/da-DK';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('da-DK', translations);
